<template>
  <v-btn
    :loading="submitButton.loading"
    :class="submitButton.class"
    :disabled="isDisabled"
    @click="$emit('click')"
  >
    <v-icon class="white--text pr-5">
      {{ submitButton.icon }}
    </v-icon>
    {{ submitButton.label }}
  </v-btn>
</template>

<script>
export default {
  name: 'SubmitButton',
  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    submitButton() {
      return this.$store.getters['order/submitButton/getButton']
    },
    isDisabled() {
      return this.submitButton.class === 'success' ? true : this.disabled
    }
  }
}
</script>

<style scoped></style>
